import { useLocation } from "react-router-dom";

export const useFragmentParams = () => new URLSearchParams(useLocation().hash.slice(1));
